import { Loosen } from "@commonlibs";
import clsx from "clsx";
import DeleteIcon from "ui/common/icons/DeleteIcon";
import useTranslate from "ui/locale/hooks/useTranslate";
import { ButtonWithIconProps } from "../ButtonWithIcon/ButtonWithIcon";
import { DeleteButtonRoot } from "./DeleteButton.style";

export type DeleteButtonProps = Loosen<Omit<ButtonWithIconProps, "variant" | "children">, "label" | "Icon">;

const DeleteButton = ({ className, label, Icon, ...rest }: DeleteButtonProps) => {
    const translate = useTranslate();

    return (
        <DeleteButtonRoot
            className={clsx("delete-button", className)}
            label={label || translate("delete")}
            Icon={Icon || DeleteIcon}
            {...rest}
        />
    );
};

export default DeleteButton;
